// Runtime config. Vite inlines VITE_* env vars at build time; default falls
// back to production API so a plain `npm run build` without env still works.

const API_BASE = (import.meta.env.VITE_API_BASE as string | undefined)
    ?? 'https://pamosi-api.raphew-pamosi.workers.dev';

export const config = {
    apiBase: API_BASE,
} as const;
